module.exports = __webpack_public_path__ + "static/media/jp-splash-photo-center.e66dce0c.jpg";